/**
 * @generated SignedSource<<a89c5ce941cd92e50ade8d3fbb5e86da>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type usePublishModalActionsSchedulePublishInfoFragment$data = {
  readonly schedulePublishInfo: {
    readonly __typename: "SchedulePublishInfo";
    readonly date: string | null | undefined;
    readonly minorEdit: boolean | null | undefined;
    readonly targetType: string | null | undefined;
    readonly versionComment: string | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "usePublishModalActionsSchedulePublishInfoFragment";
};
export type usePublishModalActionsSchedulePublishInfoFragment$key = {
  readonly " $data"?: usePublishModalActionsSchedulePublishInfoFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"usePublishModalActionsSchedulePublishInfoFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "usePublishModalActionsSchedulePublishInfoFragment",
  "selections": [
    {
      "concreteType": "SchedulePublishInfo",
      "kind": "LinkedField",
      "name": "schedulePublishInfo",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "date"
        },
        {
          "kind": "ScalarField",
          "name": "minorEdit"
        },
        {
          "kind": "ScalarField",
          "name": "targetType"
        },
        {
          "kind": "ScalarField",
          "name": "versionComment"
        },
        {
          "kind": "ScalarField",
          "name": "__typename"
        }
      ]
    }
  ],
  "type": "Content"
};

(node as any).hash = "5dc641b473052bf1fb2921bbc4960dcc";

export default node;
